import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import {
  AppCard,
  AppInput,
  AppTextArea,
  AppRemixIcon,
} from '@/layout/AppComponents';
import axios from 'axios';
import { axiosPath } from '@/routing/helpers/router';
import errorHandler from '@/layout/components/error/ErrorHandler';
import {
  identificationOptions,
  relationOptions,
  complaintOptions,
} from '../../constants/options';
import Translator from '../../../../../components/helpers/Translator';
import { useCallback } from 'react';

export default function CommunicationPipelineUserReportSentDefaultTemplate(
  props,
) {
  const { moduleBridgeHex, reportHex } = useParams();
  const { report } = props;
  const dispatch = useDispatch();
  const global = useSelector((state) => state.global);

  const handleGetFile = useCallback(
    async (salt) => {
      axios
        .post(
          axiosPath('api_r_user_module_communicationPipeline_report_file_get'),
          {
            moduleBridgeHex,
            reportHex,
            salt,
          },
        )
        .then(({ data }) => {
          window.open(data, '_blank', 'noopener,noreferrer');
        })
        .catch((e) => dispatch(errorHandler(e)));
    },
    [moduleBridgeHex, reportHex],
  );

  return (
    <AppCard bodyClassName="minHeight600">
      <div>
        <h3>
          <Translator
            file="module-communicationPipeline"
            name="identification"
          />
        </h3>
        <AppInput
          value={identificationOptions[report?.identification]?.label}
          isReadOnly
        />
        {report?.identification === 1 && (
          <div className="user-info">
            <h3 className="mt-0">
              <Translator
                file="module-communicationPipeline"
                name="first-name-last-name"
              />
            </h3>
            <AppInput value={report?.nameSurname} isReadOnly />
            <h3>
              <Translator file="module-communicationPipeline" name="email" />
            </h3>
            <AppInput value={report?.email} isReadOnly />
            <h3>
              <Translator file="module-communicationPipeline" name="phone" />
            </h3>
            <AppInput value={report?.phone} isReadOnly />
          </div>
        )}
        <h3>
          <Translator
            file="module-communicationPipeline"
            name="relationship-company-maintains-group-company"
          />
        </h3>
        <AppInput value={relationOptions[report?.relation]?.label} isReadOnly />
        <h3>
          <Translator
            file="module-communicationPipeline"
            name="conduct-reported"
          />
        </h3>
        <AppInput
          value={complaintOptions[report?.complaint]?.label}
          isReadOnly
        />
        <h3>
          <Translator
            file="module-communicationPipeline"
            name="description-facts-subject-complaint"
          />
        </h3>
        <AppTextArea
          value={report?.description}
          resize="vertical"
          height="180px"
          isReadOnly
        />
        <h3>
          <Translator
            file="module-communicationPipeline"
            name="how-became-aware-reported-facts"
          />
        </h3>
        <AppTextArea
          value={report?.howKnown}
          resize="vertical"
          height="180px"
          isReadOnly
        />
        {report?.files && Object.keys(report?.files).length > 0 && (
          <>
            <h6>
              <Translator
                file="module-communicationPipeline"
                name="documents"
              />
            </h6>
            <div className="table-responsive">
              <table className="table table-hover table-sm">
                <tbody>
                  {Object.keys(report.files).map((salt) => (
                    <tr key={salt}>
                      <td>
                        <span
                          onClick={() => handleGetFile(salt)}
                          // href={`${global.urlData.userApiUrl}m/communication-pipeline/report/get-file/${moduleBridgeHex}/${reportHex}/${salt}`}
                          title={report?.files?.[salt]?.name}
                          className="pointer"
                        >
                          <AppRemixIcon icon="file-text" />{' '}
                          {report?.files?.[salt]?.name}
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </>
        )}
      </div>
    </AppCard>
  );
}
